import { findAllLeadIfNotLoaded } from './state/action'
import { selectIsFetching, selectLeadById } from './state/selector'


export default {
    action: {
        findAllLeadIfNotLoaded,
    },
    selector: {
        selectIsFetching,
        selectLeadById,
    },
}



// WEBPACK FOOTER //
// ./src/modules/lead/index.js